module.exports = __webpack_public_path__ + "static/media/US.e6007a77.svg";